<template>
  <div class="Guard1InspectorForm">
    <!-- if edit -->
    <el-form v-if="editable">
      <CardTable>
        <div class="card-item">
          <div class="label">{{ $t("pages.wording.inspector") }}</div>
          <div class="value">{{ getUserProfile().userName }}</div>
        </div>
        <div class="card-item">
          <div class="checkAll-group">
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{
              $t("pages.wording.selectorAll")
            }}</el-checkbox>
            <el-checkbox-group v-model="checkedList" @change="handleCheckedListChange">
              <el-checkbox v-for="item in guard1Form.checkList" :label="item.code" :key="item.code">{{
                item[$i18n.locale]
              }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </CardTable>
    </el-form>
    <!-- if view -->
    <el-form v-else disabled>
      <CardTable>
        <div class="card-item">
          <div class="label">{{ $t("pages.wording.inspector") }}</div>
          <div class="value">{{ inspectData === null ? "" : inspectData.inspectOperator }}</div>
        </div>
        <div class="card-item">
          <div class="label">{{ $t("pages.wording.checkTime") }}</div>
          <div class="value">{{ viewInspectDateTime }}</div>
        </div>
        <div class="card-item">
          <div class="value">
            <div class="checkAll-group">
              <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll">{{
                $t("pages.wording.selectorAll")
              }}</el-checkbox>
              <el-checkbox-group v-model="checkedList">
                <el-checkbox v-for="item in guard1Form.checkList" :label="item.code" :key="item.code">{{
                  item[$i18n.locale]
                }}</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
      </CardTable>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { utils } from "@/utils/utils.js"
import CardTable from "@/components/common/CardTable.vue"

export default {
  name: "Guard1InspectorForm",
  components: {
    CardTable,
  },
  props: {
    inspectData: {
      type: Object,
      default: () => {},
    },
    checkItemspectData: {
      type: Array,
      default: () => [],
    },
    editable: {
      type: Boolean,
    },
    reserveRegion: {
      type: String,
      default: () => "",
    },
    reserveArea: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      reserveStatus: "entering",
      checkPointInput: [],
      checkAll: false,
      inspectResult: false,
      isIndeterminate: false,
      checkedList: [],
      checkResult: [],
      guard1Form: {
        checkList: [],
      },
    }
  },
  created() {
    this.init()
  },
  methods: {
    ...mapGetters(["getUserProfile"]),
    init() {
      this.getCheckList()
      if (this.editable === false && this.checkItemspectData != null && this.checkItemspectData.length > 0) {
        this.checkedList = this.checkItemspectData.map((item) => item.description)
        this.checkAll = this.checkedList.length === this.guard1Form.checkList.length
        this.changeCheckAllStyle(this.checkAll)
      }
    },
    handleCheckAllChange(checkedAll) {
      //控制全選框
      this.checkedList = checkedAll ? this.guard1Form.checkList.map((item) => item.code) : []
      this.changeCheckAllStyle(true)
      this.checkResult = []
      this.guard1Form.checkList.forEach((item) => {
        let obj = {}
        obj.description = item.code
        obj.result = checkedAll
        obj.resValue = checkedAll.toString()
        this.checkResult.push(obj)
      })
    },
    handleCheckedListChange(ckeckItems) {
      //控制全選框
      let checkedCount = ckeckItems.length
      this.checkAll = checkedCount === this.guard1Form.checkList.length
      this.changeCheckAllStyle(this.checkAll)
      this.checkResult = []
      this.guard1Form.checkList.forEach((item) => {
        let obj = {}
        obj.description = item.code
        obj.result = ckeckItems.includes(item.code) ? true : false
        obj.resValue = item.result ? "true" : "false"
        this.checkResult.push(obj)
      })
    },
    getInspectData() {
      return this.checkResult
    },
    getIsCheckAll() {
      return this.checkAll
    },
    changeCheckAllStyle(isCheckAll) {
      this.isIndeterminate = isCheckAll ? false : true
    },
    async getCheckList() {
      this.guard1Form.checkList = await utils.getCodeListWithCulture(
        this.reserveRegion,
        this.reserveArea,
        "entryInspectItem"
      )
    },
  },
  computed: {
    viewInspectDateTime() {
      return this.inspectData === null ? "" : utils.parseISOStringToDateTime(this.inspectData.inspectDatetime)
    },
  },
}
</script>

<style scoped>
.checkAll-group ::v-deep .el-checkbox-group {
  padding-left: 24px;
}

.checkAll-group ::v-deep .el-checkbox-group .el-checkbox {
  display: block;
}

.checkAll-group ::v-deep .el-checkbox__label {
  white-space: normal;
  vertical-align: top;
}
</style>
